import { render, staticRenderFns } from "./ProductDel.vue?vue&type=template&id=6f4f12eb&scoped=true&"
import script from "./ProductDel.vue?vue&type=script&lang=js&"
export * from "./ProductDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f12eb",
  null
  
)

export default component.exports